import EditorDocumentPicker from './editor-document-picker';

export default EditorDocumentPicker;
